<div class="nosidebarpage" id="home-div">
  <div class="heading">
    <h1 class="styledText" id="home-welcome">{{'PROJECT.HOME.WELCOME' | anessaTranslation: trigger}}</h1>
  </div>
  <div *ngIf="!isInitialFormUser()" class="text">
    <p class="large-text grey-text">
      {{'PROJECT.HOME.TEXT.0' | anessaTranslation: trigger}}
      <br>
      {{'PROJECT.HOME.TEXT.1' | anessaTranslation: trigger}}
    </p>
  </div>
  <div class="buttons">
    <button
      mat-button
      class="mat-mdc-button btn-fat btn-lg styledText x-large-text"
      (click)="open()">
      {{'PROJECT.HOME.OPEN' | anessaTranslation: trigger}}
    </button>
    <div [matTooltip]="limitToScreeningProjects() ?
    ('ACCOUNT.PERMISSIONS.ACCESS_LIMITED_TO_SCREENING_PROJECTS' | anessaTranslation: trigger) : (
      isProjectLimitReached() ? ('ACCOUNT.PERMISSIONS.PROJECT_LIMIT_REACHED' | anessaTranslation: trigger) : null
    )">
      <button
        *ngIf="!isInitialFormUser() && !isTranslator()"
        mat-button
        class="mat-mdc-button btn-fat btn-lg styledText x-large-text"
        [disabled]="limitToScreeningProjects() || isProjectLimitReached()"
        (click)="newProject()">
        {{'PROJECT.HOME.NEW' | anessaTranslation: trigger}}
      </button>
    </div>
  </div>
  <div *ngIf="canViewProjectInput() && !isInitialFormUser() && !isTranslator()" class="buttons"
    [matTooltip]="isScreeningProjectLimitReached() ? ('ACCOUNT.PERMISSIONS.SCREENING_PROJECT_LIMIT_REACHED' | anessaTranslation: trigger) : null">
    <button
      mat-button
      class="mat-mdc-button btn-fat btn-lg styledText x-large-text"
      style="width: 700px;"
      [disabled]="isScreeningProjectLimitReached()"
      (click)="onNewInitialInformation()">
      {{'PROJECT.HOME.INITIAL' | anessaTranslation: trigger}}
    </button>
  </div>
</div>

